<template>
	<insurance-list scene="record"></insurance-list>
</template>

<script>
	import insuranceList from '../insurance/insurance_list'
	
	export default {
		components: {
			insuranceList
		}
	}
</script>
